export function money(cents, currency = "USD") {
  const sym = { USD: "$", EUR: "\u20ac", GBP: "\u00a3" }[currency] || "";
  return `${sym}${((cents || 0) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  })}`;
}

export function xaf(cents, rate) {
  if (!rate) return "";
  return `${Math.round(((cents || 0) / 100) * rate).toLocaleString()} XAF`;
}

export function shortDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}
